import { render, staticRenderFns } from "./CustomerHome.vue?vue&type=template&id=487fc9f6&"
import script from "./CustomerHome.vue?vue&type=script&lang=js&"
export * from "./CustomerHome.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports